import {ReactNode} from 'react'

export default function FormikErrorComponent({children}: {children?: ReactNode}) {
  return <span className='fs-sm fw-bold text-danger'>{children}</span>
}
